"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = identity;
var _utils = require("../utils");
var _lib = require("../lib");
var _constants = require("../constants");
function identity(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message,
    countryCode = options.countryCode,
    identityType = options.identityType;
  var label = options.label || 'Field';
  var defaultMsg = "".concat(label, " has an invalid identity type");
  var defaultRegex = '^\\w*$';
  if ((0, _utils.checkValueExist)(countryCode) && (0, _utils.checkValueExist)(identityType)) {
    var code = String(countryCode).toUpperCase();
    var identityT = String(identityType).toLowerCase();
    var iType = identityT === 'ic_number' ? 'IC' : identityT.replace('_', ' ');
    defaultMsg = "".concat(label, " is not a valid ").concat(iType, " number");
    defaultRegex = _constants.RX_IDENTITY[code][identityT];
  }
  var validRegex = new RegExp(options.validRegex || defaultRegex, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !validRegex.test(value)) {
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/validations/identity.js
// module id = 1871
// module chunks = 0